import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTOBuildingApi } from '@/api/pto'
import { getUserFullName } from '@/utils/user'
import { priceFormat } from '@/utils/form/priceFormat'

const state = () => ({
  ...vuexPto.createState(),
  api: PTOBuildingApi,
  namePageDetailed: 'PtoBuildingRegisterDetailed',
  expand: 'director,objects,price,signed,remains',
  tableHeaders: [
    {
      title: 'Дата начала',
      isSortable: true,
      sortName: 'start_date'
    },
    {
      title: 'Дата окончания',
      isSortable: true,
      sortName: 'stop_date'
    },
    {
      title: 'Стройка',
      isSortable: true,
      sortName: 'name'
    },
    {
      title: 'Руководитель',
      isSortable: true,
      sortName: 'director.surname'
    },
    {
      title: 'Шифр бух.',
      isSortable: true,
      sortName: 'accounting_cipher'
    },
    {
      title: 'Заказ покупателя',
      isSortable: true,
      sortName: 'order'
    },
    {
      title: 'Стоимость',
      isSortable: true,
      sortName: 'price'
    },
    {
      title: 'Подписано',
      isSortable: true,
      sortName: 'signed'
    },
    {
      title: 'Остаток',
      isSortable: true,
      sortName: 'remains'
    },
    {
      title: 'Город заказчика',
      isSortable: true,
      sortName: 'customer_city'
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  getList: state => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.start_date || '-',
          item.stop_date || '-',
          item.name || '-',
          getUserFullName(item.director) || '-',
          item.accounting_cipher || '-',
          item.buyer_order || '-',
          item.price !== 0 ? priceFormat(item.price) : '-',
          item.signed !== 0 ? priceFormat(item.signed) : '-',
          item.remains !== 0 ? priceFormat(item.remains) : '-',
          item.customer_city || '-'
        ]
      }
    })
  }
}

const mutations = {
  ...vuexPto.createMutations()
}

const actions = {
  ...vuexPto.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
